import React from 'react';

export const gapClasses = {
  xxs: 'gap-1', // 4px
  xs: 'gap-2', // 8px
  sm: 'gap-3', // 12px
  md: 'gap-4', // 16px
  lg: 'gap-6', // 24px
  xl: 'gap-8', // 32px
};

export const alignClasses = {
  start: 'items-start', // top
  center: 'items-center', // middle
  end: 'items-end', // bottom
};

export const justifyClasses = {
  start: 'justify-start', // left
  center: 'justify-center', // center
  end: 'justify-end', // right
  between: 'justify-between', // space between
  around: 'justify-around', // space around
};

export const widthClasses = {
  full: 'w-full',
  fit: 'w-fit',
  auto: 'w-auto',
};

export const heightClasses = {
  full: 'h-full',
  fit: 'h-fit',
  auto: 'h-auto',
};

export const directionClasses = {
  row: 'flex-row',
  column: 'flex-col',
};

export interface BaseDivProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  gap?: keyof typeof gapClasses;
  align?: 'start' | 'center' | 'end';
  justify?: 'start' | 'center' | 'end' | 'between' | 'around';
  width?: keyof typeof widthClasses;
  height?: keyof typeof heightClasses;
  direction?: keyof typeof directionClasses;
  id?: string;
}

export const BaseDiv = ({
  children,
  className,
  gap = 'sm',
  align = 'center',
  justify = 'start',
  width = 'full',
  height = 'full',
  direction = 'row',
  id,
  ...props
}: BaseDivProps) => {
  return (
    <div
      id={id || ''}
      className={`flex ${directionClasses[direction]} ${gapClasses[gap]} ${className} ${alignClasses[align]} ${justifyClasses[justify]} ${widthClasses[width]} ${heightClasses[height]} ${className || ''}`}
      {...props}
    >
      {children}
    </div>
  );
};
